<template>
  <admin-wrapper
    ref="ils-easy-settings-permissions-form"
    hide-title-row
    :inputs="inputs"
    disable-sticky-buttons
    :has-buttons="false"
    @setPayloadValue="setPayload"
  />
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'IlsEasySettingsPermissions',
  components: { AdminWrapper },
  props: {
    configuration: {
      type: Object,
      default: () => {
        return {};
      },
    },
    syncing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    usersGroups: get('users/groups'),
    inputs() {
      return [
        {
          name: 'ils_easy_configuration',
          valueSubproperty: 'public_permission_group',
          translationPath: 'admin.ilsEasy.permissions.public',
          rules: [v => !!v || v === 0 || 'rules.required'],
          dataType: { name: 'select' },
          readonly: this.loading || this.syncing,
          items: this.$_objectToArray(this.usersGroups),
          itemText: 'name',
          itemValue: 'id',
          hideDetails: true,
        },
      ];
    },
    computedConfiguration: {
      get() {
        return this.configuration;
      },
      set(value) {
        this.$emit('update:configuration', value);
      },
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    setPayload({ value, subproperty }) {
      this.computedConfiguration = { ...this.computedConfiguration, [subproperty]: value };
      this.$nextTick(() => {
        this.onSave();
      });
    },
    async onSave() {
      this.loading = true;
      try {
        await this.editSingleSetting({
          key: 'ils_easy_configuration',
          body: { value: this.computedConfiguration },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
